import CryptoJS from 'crypto-js';

export class LocalStorage {

    public get(key: string): any | boolean {
        if (typeof Storage === 'undefined') {
            throw new Error('Storage (localStorage) not available!');
        }
        let item: string | null = localStorage.getItem(key);
        if (typeof item !== 'undefined' && item !== null) {
            return JSON.parse(item);
        }
        return false;
    };

    public getDecoded(key: string, token: string): any | boolean {
        if (typeof Storage === 'undefined') {
            throw new Error('Storage (localStorage) not available!');
        }
        let item: string | null = localStorage.getItem(key);
        if (typeof item !== 'undefined' && item !== null) {
            const bytes = CryptoJS.AES.decrypt(item, token);
            return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        }
        return false;
    };

    public set(key: string, value: any): void {
        if (typeof Storage === 'undefined') {
            throw new Error('Storage (localStorage) not available!');
        }
        localStorage.setItem(key, JSON.stringify(value));
    };

    public setEncoded(key: string, value: any, token: string): void {
        if (typeof Storage === 'undefined') {
            throw new Error('Storage (localStorage) not available!');
        }
        localStorage.setItem(key, CryptoJS.AES.encrypt(JSON.stringify(value), token).toString());
    };

    public remove(key: string): void {
        if (typeof Storage === 'undefined') {
            throw new Error('Storage (localStorage) not available!');
        }
        localStorage.removeItem(key);
    };

    public clear(): void {
        if (typeof Storage === 'undefined') {
            throw new Error('Storage (localStorage) not available!');
        }
        localStorage.clear();
    };

    public getSessionId() {
        let UuId = localStorage.getItem('UuId');
        if (!UuId) {
            localStorage.setItem('UuId', UuId = this.generateUUID());
        }
        return UuId;
    }

    private generateUUID(): string {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            const r = Math.random() * 16 | 0, v: number = c === 'x' ? r : ((r & 0x3) | 0x8);
            return v.toString(16);
        });
    }


}
